import Icon from '../Icon';

const testimonials = [
    {
        text: 'Rush Studio completely transformed our localization workflow. We cut our turnaround time by 40% and improved consistency across all 15 languages.',
        name: 'Sarah Jenkins',
        title: 'Localization Manager',
        avatar: '/images/demo6/review-author-1.jpg',
    },
    {
        text: 'The ability to sync directly from Figma to the translation engine is a game changer. No more copy-pasting into spreadsheets!',
        name: 'David Chen',
        title: 'Product Designer',
        avatar: '/images/demo6/review-author-2.jpg',
    },
    {
        text: 'Managing our global marketing campaigns used to be a nightmare. Rush Studio gave us the visibility and control we needed.',
        name: 'Elena Rodriguez',
        title: 'Marketing Director',
        avatar: '/images/demo6/review-author-3.jpg',
    },
    {
        text: 'The API integration is seamless. We automated our entire content delivery pipeline and haven\'t looked back.',
        name: 'Michael Chang',
        title: 'CTO',
        avatar: '/images/demo6/review-author-4.jpg',
    },
];

const Demo6Reviews4 = () => {
    return (
        <section id="reviews" className="rel reviews-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="section-title title-01 mb-60">
                            <h2 className="h2-md">Stories From Our Customers</h2>
                            <p className="p-xl">
                                See how teams are scaling their global reach with Rush Studio.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="reviews-4-holder">
                <div className="container">
                    <div className="row row-cols-1 row-cols-md-2">
                        {testimonials.map((testimonial) => (
                            <div className="col" key={testimonial.name}>
                                <div className="review-4">
                                    <div className="review-4-txt">
                                        <p className="p-lg">{testimonial.text}</p>
                                        <div className="author-data clearfix">
                                            <div className="review-avatar">
                                                <img src={testimonial.avatar} alt={`${testimonial.name} avatar`} />
                                            </div>
                                            <div className="review-author">
                                                <h6 className="h6-xl">{testimonial.name}</h6>
                                                <p className="p-md">{testimonial.title}</p>
                                                <div className="review-rating ico-15 yellow-color rating-stars" aria-label="Rated 4.5 out of 5">
                                                    {[...Array(4)].map((_, index) => (
                                                        <Icon key={`testimonial-${testimonial.name}-star-${index}`} symbol="★" decorative className="icon-star" />
                                                    ))}
                                                    <Icon symbol="½" decorative className="icon-star" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Reviews4;
